import { configureStore } from '@reduxjs/toolkit';
import tokenInfoReducer from '../features/tab/tokenInfoSlice';

export const store = configureStore({
  reducer: {
    tokenInfo: tokenInfoReducer,
  },
});
